import { SCREEN } from "helper/roleChecker/Screens";
import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";

const basePath = "/portal-attend/attend";

const getPathName = (
  type: "lack-of-time" | "list-feedback" | "late" | "register-early" | string
) => {
  switch (type) {
    case "lack-of-time":
      return "arrive-late";
    case "list-feedback":
      return "explain";
    case "register-early":
      return "register-early";
    default:
      return "register-leave";
  }
};

export const listReasonArriveLateUrl = `${basePath}/reason/arrive-late`;
export const listReasonLeaveUrl = (type: TYPE_LEAVE) =>
  `${basePath}/reason/register-leave/${type}`;

export const createReqArriveLateUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/arrive-late`;

export const getDirectionManagerUrl = `${basePath}/direction-manager`;

export const getListArriveLateUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/arrive-late/month`;

export const getListEmployeeUrl = `${basePath}/employee-relate`;

export const deleteRequestUrl = (screenCode: SCREEN, id: string, tab: string) =>
  `${basePath}/${screenCode}/${tab === "leave" ? "register-leave" : tab === "late" ? "arrive-late" : "explain"}/${id}`;

export const getPaidLeaveBalanceUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/paid-leave-balance`;

export const getTimeKeepingSummaryUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/time-keeping-summary`;

export const handleRequestUrl = (tab: string, screenCode: SCREEN) =>
  `${basePath}/${screenCode}/${getPathName(tab)}/approve`;
export const getListRequestLeaveConfigUrl = (screenCode: SCREEN, isAdmin) =>
  `${basePath}/${screenCode}${isAdmin ? "/admin" : ""}/register-leave/month`;

export const checkIsExitsReqArriveLateUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/arrive-late/pre-check`;

export const createReqLeaveUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/register-leave`;

export const postFileUrl = `portal-attend/file/upload`;

export const getLeaveManagerReqUrl = `${basePath}/register-leave/manager-approve`;

export const checkIsExitsReqLeaveUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/register-leave/pre-check`;

export const getListManagerOfDepartmentUrl = `${basePath}/manager-of-department`;

export const sendFeedbackUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/explain
`;
export const getConfigMinDateUrl = `${basePath}/config/lock-date`;

export const getListTimeKeepingHRUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/hr/time-keeping-month`;

export const getCategoryOptionUrl = (type) => `${basePath}/general/${type}`;

export const exportTimeKeepingHRUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/hr/time-keeping-month/statistic/export`;

export const exportTimeKeepingMonthUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/time-keeping-month/statistic/export`;

export const confirmTimeKeepingMonthUrl = (
  screenCode: SCREEN,
  month: string,
  year: string
) => `${basePath}/${screenCode}/time-keeping-month/confirm/${month}/${year}`;
export const getListTimeKeepingManagerUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/manage/time-keeping-month`;

export const confirmTimeKeepingUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/manage/time-keeping-month/confirm`;

export const exportTimeKeepingManagerUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/manage/time-keeping-month/statistic/export`;

export const getTimeKeepingManagerDetailUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/manage/time-keeping-month/statistic`;

export const getRangeTimeKeepingUrl = `${basePath}/range-timekeeping`;

export const getEmployeeOfManagerUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/manage/staff`;

export const getHrReportUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/hr/report`;

export const exportHrReportUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/hr/report/export`;

export const getTimeConfirmPeriodUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/manage/time-keeping-month/confirm-period`;

export const checkInOnlineApiUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/check-in-out`;

export const cancelRequestUrl = (screenCode: SCREEN, tab: string) =>
  `${basePath}/${screenCode}/${tab === "leave" ? "register-leave" : "arrive-late"}/cancel`;

export const importTimeKeepingUrl = (screenCode: SCREEN, params) =>
  `${basePath}/${screenCode}/hr/time-keeping-month/import?month=${params?.month}&year=${params?.year}`;

export const exportTemplateTimeKeepingUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/hr/time-keeping-month/template/export`;

export const getManagerApproveEarlyRegisterUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/register-early/manager-approve`;

export const createEarlyRegistrationUrl = (screenCode: SCREEN) =>
  `${basePath}/${screenCode}/register-early`;

export const getEarlyRegistrationDetailUrl = (screenCode: SCREEN, id) =>
  `${basePath}/${screenCode}/register-early/${id}`;
